import {useFeatureFlagStore} from 'iron/apps/feature-flags/src/store';
import {useFeatureFlagsApi} from 'iron/apps/feature-flags/src/api/feature-flags';
import {addToast} from 'common/components/toast-area/toast-manager';
import {ToastType} from 'common/components/toast/types';
import {payloadParamsFromModel} from 'iron/apps/feature-flags/src/components/util';
import {useTranslation} from 'common/i18n/hooks';
import {FeatureFlagApiResponse} from 'app_api/projects/feature_flags/types';
import {useContentSidenavContext} from 'common/widgets/content-sidenav/context';
import {ContentItemInfo} from 'common/widgets/content-sidenav/types';

export function useUpdateFeatureFlag(projectId: number) {
  const {updateFeatureFlag} = useFeatureFlagsApi({projectId});
  const contentSidenavContext = useContentSidenavContext();
  const setCurrentFeatureFlag = useFeatureFlagStore((state) => state.setCurrentFeatureFlag);
  const i18n = useTranslation();

  return (updatedFlag: FeatureFlagApiResponse) => {
    const payload = payloadParamsFromModel(updatedFlag);
    setCurrentFeatureFlag(updatedFlag);
    updateFeatureFlag({
      id: updatedFlag.id,
      ...payload,
    })
      .then((resp) => {
        if (`name` in payload) {
          contentSidenavContext?.updateContentSidenavItem({
            content: resp as ContentItemInfo,
          });
        }
        addToast({
          message: i18n.t(`feature-flags.page.update.success`),
          type: ToastType.SUCCESS,
          timeout: 6000,
        });
      })
      .catch((error) => {
        addToast({
          message: i18n.t(`feature-flags.page.update.error`),
          type: ToastType.ERROR,
          timeout: 6000,
        });
        setCurrentFeatureFlag(updatedFlag); // revert back to previous
        console.error(`Error updating feature flag:`, error);
      });
  };
}
